import { useQuery } from "@apollo/client";
import { useFeatureFlags } from "@app.automotus.io/components/hooks";
import { usePollInterval } from "@app.automotus.io/components/context";
import { GET_PENDING_INVOICE_REVIEW_COUNT, GetPendingInvoiceReviewCountData } from "common/graphql/queries";
import { FEATURE_FLAGS } from "@curbsuite/constants";

/**
 * Returns the count of invoices pending officer review, or `undefined` when
 * the feature flag is off or data has not yet loaded.
 *
 * Refreshes on every tick from the nearest {@link PollIntervalProvider}
 * (30 s by default) so multiple consumers share a single timer and a single
 * network request per cycle.
 */
export const usePendingInvoiceReviewCount = (): number | undefined => {
  const { isEnabled } = useFeatureFlags();
  const invoiceReviewEnabled = isEnabled(FEATURE_FLAGS.INVOICE_REVIEW_IS_ENABLED);

  const { data, refetch } = useQuery<GetPendingInvoiceReviewCountData>(GET_PENDING_INVOICE_REVIEW_COUNT, {
    skip: !invoiceReviewEnabled,
  });

  usePollInterval(() => {
    if (invoiceReviewEnabled) {
      refetch();
    }
  });

  return data?.invoicesAggregate.aggregate.count || undefined;
};
